import React from 'react';
import queryString from 'query-string';
import FlowCard from "../../../../../../CommonComponents/FlowCard/FlowCard";
import formatter from '../../../../../../utils/formatter';
import { GridDiv, FlexContainer, PageHeading } from './styles';
import { Col, Divider } from 'antd';
import EditButton from '../editButton';
import {  Heading, SectionHeading } from '../../styles';
import {
    DataHeading, SectionSpacing,
} from "../../../../../../CommonComponents/commonStyles";
import { CustomizedFlowCard } from '../exchangeReview/styles';
import { ScheduleType as ScheduleTypeConstants } from '../../constants';
import { initiateTracking, recordError } from '../../../../../../utils/commonUtil';
import { CapsuleButton } from '../../../../../../CommonComponents/Commons/commonComponents';

const ExchangeSchedule = (props) => {

    const renderFixGrid = ({ gridName, value }) => {
        return (
            <>
                <DataHeading>{gridName}</DataHeading>
                <Heading>{value}</Heading>
            </>
        )
    };

    const cardConfig = [
        {
            name: 'frequency',
            className: 'grid-with-border',
            gridWidth: '50',
            type: 'FixGrid',
            render: renderFixGrid({
                gridName: 'Frequency',
                value: props.frequency,
            }),
            pbottom: true,
        },
        {
            name: 'numberOfExchanges',
            className: 'grid-with-border',
            gridWidth: '50',
            type: 'FixGrid',
            render: renderFixGrid({
                gridName: props.isViewEdit ? 'Number of Remaining Exchanges' : 'Number of Exchanges',
                value: props.numberOfExchanges
            }),
            pbottom: true,
        },
        {
            name: 'startDate',
            gridWidth: '50',
            type: 'FixGrid',
            render: renderFixGrid({
                gridName: 'Start Date',
                value: props.startDate
            }),
            ptop: true,
        },
        {
            name: 'endDate',
            gridWidth: '50',
            type: 'FixGrid',
            render: renderFixGrid({
                gridName: 'End Date',
                value: props.endDate
            }),
            ptop: true,
        },
    ];

    const styleConfig = {
        cardBorder: false,
    };
    return (<>
        <Col xs={24} md={0}>
            <SectionSpacing>
                <Divider />
            </SectionSpacing>
        </Col>
        <Col span={24} md={{ span: 11, offset: 2 }}>
            <FlexContainer>
                <SectionHeading>Exchange Schedule</SectionHeading>
                {props.edit && <CapsuleButton iconType="edit" text="Edit" onClick={(e) => {
                    try {
                        let params = props.location && queryString.parse(props.location.search);
                        const scheduleTypeLabel = props.scheduleType === ScheduleTypeConstants.onetime ? 'One Time Exchange' : 'Recurring Exchange';
                        if(params) {
                            initiateTracking('edit', 'View and Edit Exchange', 'Exchange Schedule', `Edit - ${scheduleTypeLabel}`);
                        } else {
                            initiateTracking('edit', 'Recommend An Exchange', 'Step 3 Review exchange and submit - Exchange Schedule', `Edit - ${scheduleTypeLabel} - Body`);
                        }
                        params = params ? {...params, edit: true} : {edit: true}
                        props.history.push({
                            pathname: `/investments/recommend-an-exchange/${props.id}/from`,
                            search: queryString.stringify(params)
                        });
                    } catch (error) {
                        recordError(error);
                    }
                }} />}
            </FlexContainer>        
            <CustomizedFlowCard total="true">
                <FlowCard
                    cardConfig={cardConfig}
                    styleConfig={styleConfig}
                />
            </CustomizedFlowCard>
        </Col>
    </>
    );
};

export default ExchangeSchedule;